import { useApi } from '@hooks/useApi';
import { SharedDashboard } from '@protos/v2/dashboard';
import { useCallback, useEffect, useState } from 'react';

export const useSharedDashboards = () => {
  const [sharedDashboards, setSharedDashboards] = useState<SharedDashboard[]>([]);
  const { apiClient } = useApi();

  const getSharedDashboards = useCallback(async () => {
    if (!apiClient) return;
    const response = await apiClient.getSharedDashboards();
    if (response) {
      setSharedDashboards(response.filter(d => !d.is_accepted));
    }
  }, [apiClient]);

  const manageSharedDashboard = useCallback(
    async (dashboardId: number, accept: boolean) => {
      try {
        if (accept) {
          await apiClient?.acceptSharedDashboard(dashboardId);
        } else {
          await apiClient?.rejectSharedDashboard(dashboardId);
        }
      } catch (e) {
        console.error(e);
      } finally {
        getSharedDashboards();
      }
    },
    [apiClient]
  );

  useEffect(() => {
    getSharedDashboards();
  }, [apiClient]);

  return {
    sharedDashboards,
    manageSharedDashboard,
  };
};
